import Vue from 'vue';
import Vuex from 'vuex';

// eslint-disable-next-line
import { AuthState } from '@/store/auth';
// eslint-disable-next-line
import {BankAccountsState} from "@/store/bank-accounts";

Vue.use(Vuex);

export interface RootState {
  auth: AuthState;
  bankAccounts: BankAccountsState;
}

export default new Vuex.Store<RootState>({});
